var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImport2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M17.477 5.333a1.143 1.143 0 0 0-2.286 0v13.29l-1.938-1.945a1.143 1.143 0 1 0-1.62 1.613l3.889 3.904a1.143 1.143 0 0 0 1.662-.043l3.845-3.861a1.143 1.143 0 0 0-1.62-1.613l-1.932 1.94V5.334z",
    fill: "#1080ff",
    fillOpacity: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.512 11.644h1.244a4.912 4.912 0 0 1 4.912 4.913v6.512a4.9 4.9 0 0 1-4.9 4.9H8.915A4.914 4.914 0 0 1 4 23.056v-6.514a4.9 4.9 0 0 1 4.9-4.898h1.256",
    stroke: "#1080ff",
    strokeOpacity: 0.2,
    strokeWidth: 2.286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImport2);
export default __webpack_public_path__ + "static/media/import_2.221c7af05ab2150b2cd59e6f6ef2baec.svg";
export { ForwardRef as ReactComponent };